/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab.ts";
import { courseRegistrationManagementDetailsViewModelSchema } from "../courseRegistrationManagementDetailsViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab200Schema =
  z.lazy(
    () => courseRegistrationManagementDetailsViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidDetailsTabQueryResponse>;
